
import moment from 'moment'

export function numberToPercentage (number) {
  if (isNaN(number) === false) {
    return number.toFixed(2) + '%'
  }
}

export function shortDate (value) {
  if (value) {
    return moment(String(value)).format('MMM Do \'YY')
  }
}

export function shortTime (value) {
  if (value) {
    return moment(String(value)).format('DD/MM HH:mm')
  }
}

export function longDate (value) {
  if (value) {
    return moment(String(value)).format('LLL')
  }
}

export function timeAgo (value) {
  if (value) {
    return moment(String(value)).fromNow()
  }
}
